import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Appointment } from 'models/AppointmentModel';
import { ControlSession } from 'components/common/ControlSession';

const AppointmentList: React.FC = () => {
  const width = { client: 17, doctor: 12, location: 9, date: 9, start: 7, end: 7, type: 11, comment:11, postcheck:11 }
  const [formId, formName] = [Code.Form.Id.APPOINTMENT, Code.Form.Name.APPOINTMENT];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage, showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [appointmentData, setAppointmentData] = useState<Appointment[]>([]); 
  const [selectedAppointment, setselectedAppointment] = useState<Appointment | null>(null);
  const [doctorId, setDoctorId] = useState<number>(1);
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const triggers = [pno, pageRows, search, activeId, doctorId, startDate, endDate];
  const Privilege = Hooks.Privilege.List(formId);
  const PriClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const locationId = Utility.Storage.LocationId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.DOCTOR, Code.Option.Common.ALL, setDoctorOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Appointment.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Client.Id,
        Name.Client.FullName,
        Name.Doctor.FullName,
        Name.Common.BranchName, 
        Name.Appointment.StartDate, 
        Name.Appointment.StartTime, 
        Name.Appointment.EndTime, 
        Name.Common.TypeName, 
        Name.Appointment.Comment, 
        Name.Common.PostCheckName, 
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
      ...(doctorId != 1 && { doctor_id: doctorId }),
      ...(startDate != '' && { start_date: startDate }),
      ...(endDate != '' && { end_date: endDate }),
    });
     
    await API.Data.List<Appointment>(url, setAppointmentData, setError, setLoading); 
  }, triggers);

  

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <ControlSession startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
              <Control.Dropdown title={Title.Doctor} value={doctorId} options={doctorOptions} onChange={(value) => { setDoctorId(value);  callListData();  }} />
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError ) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, appointmentData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Client, width.client], 
                [Title.Doctor, width.doctor], 
                [Title.Location, width.location], 
                [Title.Date, width.date], 
                [Title.Start, width.start], 
                [Title.End, width.end],
                [Title.Type, width.type],
                [Title.Comment, width.comment],
                ["Post Check", width.postcheck], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(appointmentData) && (
              <Control.Grid.Row>
                {appointmentData.map((appointmentData) => { return (
                <Control.Grid.Data<Appointment> key={appointmentData.appointment_id} itemKey={appointmentData.appointment_key} data={appointmentData} setMenuPosition={setMenuPosition} setSelectedData={setselectedAppointment} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={appointmentData.appointment_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, appointmentData.appointment_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Link value={Utility.Get.FullName(appointmentData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(PriClient, Code.Form.Name.CLIENT, appointmentData.client_id)} width={width.client} iframeRef={iframeRef} />
                  <Control.Grid.Items values={[
                    [Utility.Get.FullName(appointmentData,Code.Form.Name.DOCTOR), width.doctor],
                    [appointmentData.branch_name, width.location],
                    [Utility.Format.DateOnly(appointmentData.appointment_start_date), width.date],
                    [Utility.Format.Time(appointmentData.appointment_start_time), width.start],
                    [Utility.Format.Time(appointmentData.appointment_end_time), width.end],
                    [appointmentData.type_name, width.type],
                    [appointmentData.appointment_comment, width.comment],
                    [appointmentData.postcheck_name, width.postcheck],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={appointmentData.appointment_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={appointmentData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedAppointment?.appointment_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedAppointment?.appointment_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default AppointmentList;